import { NECESSARY_COOKIES_ID, hasConsent } from "@asosteam/asos-web-consent";

export default () => {
  const targetingAndAdvertisingAllowed = hasConsent([NECESSARY_COOKIES_ID]);
  const nonPersonalizedAds = targetingAndAdvertisingAllowed ? 0 : 1;

  window.googletag.pubads().setRequestNonPersonalizedAds(nonPersonalizedAds);
};
